import TaskTable from "./TaskTable";

const MyTaskTable = ({ rowData, onRowClick }) => {
  return <TaskTable rowData={rowData} onRowClick={onRowClick} mode="mytasks" />;
};

export default MyTaskTable;
